function gtagSeguro(evento, params = {}) {
    if (typeof window.gtag !== "function") return;
    if (document.referrer.includes("eventsmanager.facebook.com")) return; // el debugger de Meta visita la web con headless browser — no aplica en app Flutter
    window.gtag("event", evento, params);
}



export function gtagVerContenido({ nombre, id, precio, categoria }) {
    gtagSeguro("view_item", {
        currency: "COP",
        value:    precio,
        items: [{
            item_id:       id,
            item_name:     nombre,
            item_category: categoria || "",
            price:         precio,
            quantity:      1,
        }],
    });
}



export function gtagAgregarAlCarrito({ nombre, id, precio, categoria }) {
    gtagSeguro("add_to_cart", {
        currency: "COP",
        value:    precio,
        items: [{
            item_id:       id,
            item_name:     nombre,
            item_category: categoria || "",
            price:         precio,
            quantity:      1,
        }],
    });
}



export function gtagIniciarReserva({ nombre, id, precio }) {
    gtagSeguro("begin_checkout", {
        currency:  "COP",
        value:     precio,
        items: [{
            item_id:   id,
            item_name: nombre,
            price:     precio,
            quantity:  1,
        }],
    });
}



export function gtagCompraCompletada({ transaccionId, monto, moneda = "COP", descuentoAplicado = false }) {
    gtagSeguro("purchase", {
        transaction_id: transaccionId,
        value:          monto,
        currency:       moneda,
        // "coupon" es un parámetro reservado de GA4 ecommerce — queda reportable nativo en
        // Monetización > Compras sin crear un evento aparte.
        ...(descuentoAplicado ? { coupon: "primera_compra_5pct" } : {}),
    });
}



export function gtagAgregarFavorito({ nombre, id, precio, categoria }) {
    gtagSeguro("add_to_wishlist", {
        currency: "COP",
        value:    precio,
        items: [{
            item_id:       id,
            item_name:     nombre,
            item_category: categoria || "",
            price:         precio,
            quantity:      1,
        }],
    });
}



// "select_item" es el evento RESERVADO de GA4 para elegir un ítem de una lista: item_list_id /
// item_list_name quedan reportables nativo (Monetización > Rendimiento de listas de ítems) sin crear
// dimensiones personalizadas. Se dispara en serviciosRelacionados.jsx. bloque: "vendedor" | "similares".
export function gtagClickServicioRelacionado({ bloque, idOrigen, idDestino, nombre, categoria, precio, posicion }) {
    const listaId     = bloque === "vendedor" ? "relacionados_vendedor" : "relacionados_similares";
    const listaNombre = bloque === "vendedor" ? "Más servicios del vendedor" : "Servicios similares";

    gtagSeguro("select_item", {
        item_list_id:   listaId,
        item_list_name: listaNombre,
        id_origen:      idOrigen,
        items: [{
            item_id:        idDestino,
            item_name:      nombre || "",
            item_category:  categoria || "",
            item_list_id:   listaId,
            item_list_name: listaNombre,
            index:          posicion,
            price:          precio || 0,
            quantity:       1,
        }],
    });
}



export function gtagRegistroCompletado({ metodo = "email" }) {
    gtagSeguro("sign_up", {
        method: metodo, // "email", "google", "apple"
    });
}



export function gtagLogin({ metodo = "email" }) {
    gtagSeguro("login", {
        method: metodo, // "email", "google", "apple"
    });
}



export function gtagPonerEnRevision({ idServicio, categoria }) {
    gtagSeguro("poner_en_revision", {
        item_id:       idServicio,
        item_category: categoria,
    });
}



export function gtagSuscribirKlaviyo({ origen = "formulario" }) {
    gtagSeguro("generate_lead", {
        origen, // "footer", "cuenta", "registro"
    });
}



export function gtagClickDescargaApp({ plataforma }) {
    gtagSeguro("click_descarga_app", {
        plataforma, // "ios" o "android"
    });
}



export function gtagIniciarCreacionServicio() {
    gtagSeguro("iniciar_creacion_servicio");
}



export function gtagPasoCreacionServicio({ paso, totalPasos }) {
    gtagSeguro("paso_creacion_servicio", { paso, total_pasos: totalPasos });
}



export function gtagClickLlamarAyuda({ numero }) {
    gtagSeguro("click_llamar_ayuda", {
        numero,
    });
}



export function gtagClickWhatsAppAyuda() {
    gtagSeguro("click_whatsapp_ayuda");
}



// "search" es el evento RESERVADO de GA4 para búsquedas (search_term es su parámetro estándar,
// reportable nativo en Informes > Interacción sin configuración extra). Se dispara en las 4
// variantes de búsqueda (lista, mapa por ciudad, cerca de mí desde Búsqueda, cerca de mí en Home).
export function gtagBusquedaRealizada({ termino, categoria, subcategoria, ciudad, ordenar }) {
    gtagSeguro("search", {
        search_term: termino || "",
        categoria: categoria || "",
        subcategoria: subcategoria || "",
        ciudad: ciudad || "",
        ordenar: ordenar || "",
    });
}
